import { StyledTechnology } from "./styled";

import { useState } from "react";

//CONTEXT
import { useContext } from "react";
import { TechContext } from "../../context/TechContext";


const Technology = ({tech})=>{

    const {viewTechDetails} = useContext(TechContext);

    return(
        <StyledTechnology onClick={()=>viewTechDetails(tech)}>
            <h3>{tech.title}</h3>
            <div>
                <span>{tech.status}</span>
            </div>
        </StyledTechnology>
    )

}

export default Technology